module.exports = __WEBPACK_EXTERNAL_MODULE_15__;


//////////////////
// WEBPACK FOOTER
// external "fenix-ui-metadata-viewer"
// module id = 15
// module chunks = 0